/* ================================================================
   Selleasy (lb-upsell) — behaviour fix for the theme's Quick Buy / Quick View.

   Selleasy attaches an add-to-cart listener (lb-atc-listener="true") to
   EVERY add-to-cart button on the page and, on click, hijacks it to open its
   "Frequently bought together" popup ("¡Van bien juntos!") instead of letting
   the theme add the product. That is the intended behaviour for the MAIN
   product's "Añadir al carrito", but Selleasy also hijacks the theme's own
   upsell "Compra rápida" buttons and the Quick View drawer's add-to-cart —
   so opening the drawer, picking a variant and adding wrongly showed the FBT
   popup (with the main product as "added") and added nothing to the cart.

   Fix: intercept the click in the CAPTURE phase for add-to-cart buttons that
   live inside the theme's upsell blocks or the Quick View drawer, and call
   stopPropagation() so Selleasy's own listener never runs. We do NOT call
   preventDefault(), so the native form submit still fires and the theme adds
   the product normally (then opens the cart drawer). The MAIN product ATC is
   left untouched, so its FBT popup keeps working as designed. */
(function () {
  'use strict';

  // Contexts whose add-to-cart the THEME owns (upsell cards + Quick View drawer).
  var THEME_ADD_CONTEXTS =
    '[data-upsell-holder], [data-product-form-upsell], [class*="popup-quick-view"]';
  var ADD_BUTTONS = 'button[name="add"], [data-add-to-cart]';

  // Capture phase runs before Selleasy's target/bubble listener regardless of
  // registration order, and also catches buttons rendered later (e.g. the
  // Quick View drawer's add button) via event delegation on the document.
  document.addEventListener(
    'click',
    function (e) {
      var target = e.target;
      if (!target || !target.closest) return;
      var btn = target.closest(ADD_BUTTONS);
      if (btn && btn.closest(THEME_ADD_CONTEXTS)) {
        e.stopPropagation();
      }
    },
    true
  );
})();

/* LimeBundle / LastBundle upsell popup — text + badge overrides.
   The app renders <lb-upsell-dialog> async. We watch for it and:
   - Update title to "¡Van bien juntos!"
   - Replace the trigger product's checkbox with a green "Agregado" badge
   - Rename CTAs to "AGREGAR COMPLEMENTOS" and "Perder oferta"
   Logic (variants, add-to-cart, open/close) is owned by the app. */
(function () {
  'use strict';

  var CHECK_SVG =
    '<svg class="lb-agregado-check" viewBox="0 0 24 24" fill="none" stroke="#1FA557" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<circle cx="12" cy="12" r="10"></circle>' +
    '<polyline points="8 12 11 15 16 9"></polyline>' +
    '</svg>';

  function applyOverrides(root) {
    if (!root) return;

    // 1. Title text
    var title = root.querySelector('.lb-popup-cont-head-title');
    if (title) {
      var t = title.textContent.trim();
      if (t === 'Van bien juntos' || t === 'Van bien juntos!' || t === '¡Van bien juntos') {
        title.textContent = '¡Van bien juntos!';
      }
    }

    // 2. Replace trigger checkbox with "Agregado" badge
    var triggerWrap = root.querySelector('.lb-popup-cont-trigger-checkbox');
    if (triggerWrap && !triggerWrap.querySelector('.lb-agregado-badge')) {
      var badge = document.createElement('div');
      badge.className = 'lb-agregado-badge';
      badge.setAttribute('role', 'status');
      badge.setAttribute('aria-label', 'Producto agregado');
      badge.innerHTML =
        '<span class="lb-agregado-line" aria-hidden="true"></span>' +
        CHECK_SVG +
        '<span class="lb-agregado-text">Agregado</span>';
      triggerWrap.appendChild(badge);
    }

    // 3. CTA copy
    var buttons = root.querySelectorAll('.lb-button');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      var txt = btn.textContent.trim();
      if (txt === 'Agregar al carrito' || txt === 'Add to cart') {
        btn.textContent = 'AGREGAR COMPLEMENTOS';
      } else if (txt === 'Perder la oferta' || txt === 'Skip offer') {
        btn.textContent = 'Perder oferta';
      }
    }
  }

  function isDialogVisible(el) {
    if (!el || !el.isConnected) return false;
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden' || parseFloat(style.opacity) === 0) {
      return false;
    }
    var rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  var scrollLockY = 0;
  var bodyLocked = false;

  function lockBody() {
    if (bodyLocked) return;
    scrollLockY = window.scrollY || window.pageYOffset || 0;
    var body = document.body;
    body.style.position = 'fixed';
    body.style.top = '-' + scrollLockY + 'px';
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';
    body.classList.add('lb-modal-open');
    bodyLocked = true;
  }

  function unlockBody() {
    if (!bodyLocked) return;
    var body = document.body;
    body.style.position = '';
    body.style.top = '';
    body.style.left = '';
    body.style.right = '';
    body.style.width = '';
    body.classList.remove('lb-modal-open');
    window.scrollTo(0, scrollLockY);
    bodyLocked = false;
  }

  function syncBodyLock() {
    var dialogs = document.querySelectorAll('lb-upsell-dialog');
    var anyVisible = false;
    for (var i = 0; i < dialogs.length; i++) {
      if (isDialogVisible(dialogs[i])) { anyVisible = true; break; }
    }
    if (anyVisible) lockBody();
    else unlockBody();
  }

  function init() {
    // Apply once if already mounted
    var existing = document.querySelectorAll('lb-upsell-dialog');
    for (var i = 0; i < existing.length; i++) applyOverrides(existing[i]);
    syncBodyLock();

    // Watch for future mounts / re-renders
    var observer = new MutationObserver(function () {
      var nodes = document.querySelectorAll('lb-upsell-dialog');
      for (var i = 0; i < nodes.length; i++) applyOverrides(nodes[i]);
      syncBodyLock();
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class', 'open', 'hidden', 'aria-hidden']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
